import React from 'react';
import PropTypes from 'prop-types';
import { SearchPage } from '../components/Views/SearchPage';
import {
  // fromUrlToObj,
  getLocaleFromBrowser,
  getSeoData
} from '../utils/helpers';
import Layout from '../components/Layout/Layout';
import { getStaticData } from '../utils/helpers/getStaticData';
import {
  // getDataForTransformationsQuery,
  searchItemsQuery,
  searchTotalCountQuery,
  searchVippedAllQuery
} from '../api/queries';
// import { getBreadcrumbs } from '../utils/helpers/getBreadcrumbs';
// import { getSearchResultInitialQueryParams } from '../hooks/useSearchResultItems';
// import { formatSearchResultSeoData } from '../utils/helpers/seo';
// import { setCurrentFiltersToStore } from '../utils/helpers/search';
import CONFIG from '../config';
import { MapViewQueryParam } from '../components/ItemsMap/types';

const Search = ({ transformedObj, h1, breadcrumbs, isSearchPage }) => {
  const safeTransformedObj = transformedObj || { filter: {} };
  return (
    <SearchPage
      transformedObj={safeTransformedObj}
      h1={h1}
      breadcrumbs={breadcrumbs}
      isSearchPage={isSearchPage}
    />
  );
};

Search.getInitialProps = async ({
  apolloClient,
  asPath,
  query,
  res,
  req,
  store,
  lng: ctxLng
}) => {
  let currentLang;
  if (typeof window !== 'undefined') {
    currentLang = getLocaleFromBrowser();
  } else {
    currentLang = ctxLng || CONFIG.defaultLocale;
  }
  currentLang = currentLang || CONFIG.defaultLocale;

  // const [dataForTransform, rawSeoData] = await Promise.all([
  //   apolloClient.query({ query: getDataForTransformationsQuery }),
  //   getSeoData(apolloClient, asPath, req),
  //   // getStaticData primes the Apollo cache on the server.
  //   // Without this call, the data won't be included in the final HTML,
  //   // which is critical for search engine indexing
  //   getStaticData(apolloClient)
  // ]);

  // const transformedObj = fromUrlToObj(dataForTransform, query);
  const transformedObj = {
    filter: {
      cityId: '1',
      categoryId: '1',
      category_touched: true,
      leased: false
    },
    sorting: null
  };

  // Handle invalid URLs
  if (transformedObj.noMatch) {
    // Set 404 status code only on the server side
    if (res) {
      res.statusCode = 404;
    }
    // Return early to avoid runtime errors when accessing transformedObj.filter below
    return { statusCode: 404 };
  }

  // const formattedSeoData = formatSearchResultSeoData(
  //   rawSeoData,
  //   currentLang,
  //   dataForTransform.data,
  //   transformedObj.filter
  // );
  //
  // const { breadcrumbs } = getBreadcrumbs(
  //   dataForTransform?.data,
  //   transformedObj.filter,
  //   'search-result'
  // );

  // setCurrentFiltersToStore(transformedObj, store, dataForTransform);

  // eslint-disable-next-line camelcase
  const { category_touched, ...filtersWithoutCategoryTouched } =
    transformedObj.filter;
  transformedObj.filter = filtersWithoutCategoryTouched;
  //
  // const { vipAllQueryVariables } =
  //   getSearchResultInitialQueryParams(
  //     transformedObj.filter,
  //     transformedObj.sorting
  //   );

  // console.log(vipAllQueryVariables, '----')
  const itemsQueryVariables = {
    first: 16,
    filter: { cityId: '1', categoryId: '1', leased: false },
    sort: 'BUMPED_AT_DESC'
  };
  const vipAllQueryVariables = {
    vipLimit: 8,
    vipFilter: {
      cityId: '1',
      categoryId: '1',
      leased: false,
      scope: 'VIPPED_PURE'
    },
    residenceLimit: 4,
    residenceFilter: {
      cityId: '1',
      categoryId: '1',
      leased: false,
      scope: 'VIPPED_APARTMENTS'
    },
    sort: 'RANDOM'
  };
  const isMapView = query[MapViewQueryParam.itemsView] === 'map';

  await Promise.all([
    getSeoData(apolloClient, asPath, req),
    apolloClient.query({
      query: isMapView ? searchTotalCountQuery : searchItemsQuery,
      variables: itemsQueryVariables
    }),
    apolloClient.query({
      query: searchVippedAllQuery,
      variables: vipAllQueryVariables
    }),
    getStaticData(apolloClient)
  ]);

  return {
    transformedObj,
    seoData: null,
    h1: '',
    isSearchPage: true,
    breadcrumbs: [],
    currentLang
  };
};

Search.propTypes = {
  transformedObj: PropTypes.object,
  breadcrumbs: PropTypes.array,
  h1: PropTypes.string,
  seoData: PropTypes.object,
  isSearchPage: PropTypes.bool,
  currentLang: PropTypes.oneOf(['az', 'ru'])
};

Search.getLayout = (page, pageProps) => (
  <Layout isBackgroundBanner isBanner pageProps={pageProps}>
    {page}
  </Layout>
);

export default Search;
